// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C1VK","delete":"styles_delete__2nL_K","update":"styles_update__eP90E","add":"styles_add__3QXkm"};